import React, { memo } from "react";
import RequestImageGallery from "./RequestImageGallery";
import { ftmRequestStatus } from "../../../utils";

const RequestDetailsCard = memo(({ request }) => {
    const { icon, color, text } = ftmRequestStatus(request?.ftm_request_is_accept);

    return (
        <div className="card mb-3">
            <div className="card-body p-3">
                <div className="d-flex">
                    <i className={`material-icons text-${color}`} style={{ fontSize: "40px" }}>
                        {icon}
                    </i>
                    <div className="ms-2 my-auto">
                        <h6 className="mb-0">{text}</h6>
                        <p className="text-xs mb-0">#{request?.ftm_request_id}</p>
                    </div>
                </div>
                <p className="mt-3 mb-0 text-sm">
                    <b>Reason Description</b>
                </p>
                <p className="mt-0 text-sm">{request?.ftm_request_description}</p>
                <p className="mt-3 mb-0 text-sm">
                    <b>Reason Images</b>
                </p>
                <p className="mt-0 text-sm">
                    <RequestImageGallery images={request?.ftm_request_images} />
                </p>
            </div>
        </div>
    );
});

export default RequestDetailsCard;